export const ShiftCell = ({
  isActive,
  label,
  children,
}: {
  isActive: boolean
  label: string
  children?: React.ReactNode
}) => (
  <div
    className={`relative h-[148px] w-full min-w-0 flex flex-col items-start justify-center gap-[10px] overflow-hidden px-4 py-3 ${
      isActive ? "bg-[#E2E8F0]" : ""
    }`}
  >
    {isActive && (
      <>
        <span className="min-w-0 max-w-full truncate text-sm font-medium leading-[1.5] text-[#62748E]">
          {label}
        </span>
        {children}
      </>
    )}
  </div>
)
